<script>
import { required } from "vuelidate/lib/validators";
import { equalTo } from "../../../helpers/validator_extend_function";

export default {
  components: {},
  props: {},
  data() {
    return {
      invalidCheck: "",
    };
  },
  validations: {
    invalidCheck: { required, equalTo: equalTo(true) },

    form: ["invalidCheck"],
  },
  methods: {
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">تعليمات وشروط التقديم</h5></div>

      <div class="col-md-12">
        <ol>
          <li>
            <p>
              هذه الاستمارة خاصة بالأشخاص الذي يقدمون خدمات تطوعية مجانية ضمن الانشطة التي
              ترعاها هيئة الحشد الشعبي لخدمة المجتمع او الانشطة التي يقوم بها الافراد
              لخدمة بلدهم.
            </p>
          </li>
          <li>
            <p>هذه الاستمارة لا تعبر عن طلبات التعيين و التوظيف.</p>
          </li>
          <li>
            <p>
              المتطوع الذي يعمل مع الحشد الشعبي لا يعتبر منتميا رسميا للحشد وانما هو جزء
              من أمة الحشد.
            </p>
          </li>
          <li>
            <p>
              هذه الاستمارة ينظمها (مركز العمل التطوعي) في المديرية العامة للعلاقات و
              الخدمات الاجتماعية/هيئة الحشد الشعبي .
            </p>
          </li>
          <li>
            <p>
              بعد التدقيق يصدر مركز العمل التطوعي في الحشد الشعبي هوية العمل التطوعي-
              "باج" - رسمية لمزاولة العمل التطوعي.
            </p>
          </li>
          <li>
            <p>تحجب الاستمارة في حال كان هناك اي معلومات غير صحيحة عند التسجيل .</p>
          </li>
        </ol>

        <div class="form-check check-promise mb-3">
          <label class="form-check-label" for="invalidCheck">
            اتعهد بصحة كافة البيانات التي سيتم ادخالها وبخلافه تهمل الاستمارة .
          </label>
          <input
            class="form-check-input"
            type="checkbox"
            value=""
            id="invalidCheck"
            v-model="invalidCheck"
            :class="{ 'is-invalid': $v.invalidCheck.$error }"
          />
          <div v-if="$v.invalidCheck.$error" class="invalid-feedback">
            <span v-if="!$v.invalidCheck.required || !$v.invalidCheck.equalTo"
              >للتقديم على الاستمارة يجب الموافقة على التعهد</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
